<div class="dpe row g-3">
  <!-- ─────────────────────────── Policy list ─────────────────────────── -->
  <div class="col-md-4">
    <div class="card shadow-sm h-100">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span class="fw-bold">Data Policies</span>
        <button class="btn btn-sm btn-primary" (click)="startCreate()" [disabled]="creating">
          <i class="bi bi-plus-lg"></i> New
        </button>
      </div>

      <!-- New-policy form -->
      <div class="card-body border-bottom" *ngIf="creating">
        <div class="mb-2">
          <label class="form-label small fw-bold mb-1">Name</label>
          <input class="form-control form-control-sm" [(ngModel)]="newPolicy.name" placeholder="Policy name">
        </div>
        <div class="mb-2">
          <label class="form-label small fw-bold mb-1">Root Schema</label>
          <select class="form-select form-select-sm" [(ngModel)]="newPolicy.rootSchemaName"
                  (ngModelChange)="onNewPolicySchemaChange()">
            <option value="">— select schema —</option>
            <option *ngFor="let s of schemas" [value]="s">{{ s }}</option>
          </select>
        </div>
        <div class="mb-2">
          <label class="form-label small fw-bold mb-1">Root Table</label>
          <select class="form-select form-select-sm" [(ngModel)]="newPolicy.rootTableName"
                  [disabled]="!newPolicy.rootSchemaName">
            <option value="">— select table —</option>
            <option *ngFor="let t of tablesFor(newPolicy.rootSchemaName)" [value]="t">{{ t }}</option>
          </select>
        </div>
        <div class="d-flex flex-wrap gap-3 mb-2">
          <div class="form-check form-check-sm">
            <input class="form-check-input" type="checkbox" id="np-canEdit" [(ngModel)]="newPolicy.canEdit">
            <label class="form-check-label small" for="np-canEdit">Editable</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="np-edit" [(ngModel)]="newPolicy.rootCanEditRecord">
            <label class="form-check-label small" for="np-edit">Edit rec.</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="np-add" [(ngModel)]="newPolicy.rootCanAddRecord">
            <label class="form-check-label small" for="np-add">Add rec.</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="np-del" [(ngModel)]="newPolicy.rootCanDeleteRecord">
            <label class="form-check-label small" for="np-del">Delete rec.</label>
          </div>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-sm btn-success" (click)="submitCreate()" [disabled]="!newPolicyValid">Create</button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelCreate()">Cancel</button>
        </div>
      </div>

      <!-- List -->
      <ul class="list-group list-group-flush dpe-list">
        <li *ngFor="let p of policies; trackBy: trackByPolicy"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-start"
            [class.active]="p.id === selectedPolicyId"
            (click)="selectPolicy(p)">
          <div class="me-2">
            <div class="fw-bold">{{ p.name }}</div>
            <div class="small text-muted" *ngIf="p.rootSchema || p.rootTable">
              {{ p.rootSchema }}.{{ p.rootTable }}
            </div>
          </div>
          <div class="text-end">
            <span class="badge" [class.bg-success]="p.isEnabled" [class.bg-secondary]="!p.isEnabled">
              {{ p.isEnabled ? 'Enabled' : 'Disabled' }}
            </span>
            <div class="mt-1">
              <button class="btn btn-xs"
                      [class.btn-outline-danger]="p.isEnabled"
                      [class.btn-outline-success]="!p.isEnabled"
                      (click)="toggleEnabled(p, $event)">
                {{ p.isEnabled ? 'Disable' : 'Enable' }}
              </button>
            </div>
          </div>
        </li>
        <li class="list-group-item text-muted small" *ngIf="policies.length === 0 && !creating">
          No data policies for this client yet.
        </li>
      </ul>
    </div>
  </div>

  <!-- ─────────────────────────── Policy detail ─────────────────────────── -->
  <div class="col-md-8">
    <div class="card shadow-sm h-100" *ngIf="detail; else noSelection">
      <!-- Header -->
      <div class="card-header d-flex justify-content-between align-items-center">
        <div>
          <ng-container *ngIf="!editingHeader; else editHeaderTpl">
            <span class="fw-bold fs-5">{{ detail.name }}</span>
            <span class="badge bg-info ms-2" *ngIf="detail.canEdit">Editable</span>
            <span class="badge ms-2" [class.bg-success]="detail.isEnabled" [class.bg-secondary]="!detail.isEnabled">
              {{ detail.isEnabled ? 'Enabled' : 'Disabled' }}
            </span>
          </ng-container>
          <ng-template #editHeaderTpl>
            <div class="d-flex align-items-center gap-2">
              <input class="form-control form-control-sm" style="width:250px" [(ngModel)]="headerDraft.name">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="hd-canEdit" [(ngModel)]="headerDraft.canEdit">
                <label class="form-check-label small" for="hd-canEdit">Editable</label>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="d-flex gap-2">
          <ng-container *ngIf="!editingHeader; else editHeaderActions">
            <button class="btn btn-sm btn-outline-secondary" (click)="startEditHeader()">Rename</button>
          </ng-container>
          <ng-template #editHeaderActions>
            <button class="btn btn-sm btn-success" (click)="saveHeader()" [disabled]="!headerDraft.name.trim()">Save</button>
            <button class="btn btn-sm btn-outline-secondary" (click)="cancelEditHeader()">Cancel</button>
          </ng-template>
        </div>
      </div>

      <div class="card-body dpe-detail">
        <!-- ───────── Tables ───────── -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="fw-bold mb-0">Tables</h6>
          <button class="btn btn-sm btn-outline-primary" (click)="startAddTable()"
                  [disabled]="addingTable">
            <i class="bi bi-plus-lg"></i> Add Table
          </button>
        </div>

        <!-- Add-table form -->
        <div class="border rounded p-2 mb-3 bg-light" *ngIf="addingTable">
          <div class="row g-2 align-items-end">
            <div class="col">
              <label class="form-label small fw-bold mb-1">Schema</label>
              <select class="form-select form-select-sm" [(ngModel)]="newTable.schemaName"
                      (ngModelChange)="onAddTableSchemaChange()">
                <option value="">— select —</option>
                <option *ngFor="let s of schemas" [value]="s">{{ s }}</option>
              </select>
            </div>
            <div class="col">
              <label class="form-label small fw-bold mb-1">Table</label>
              <select class="form-select form-select-sm" [(ngModel)]="newTable.tableName"
                      [disabled]="!newTable.schemaName">
                <option value="">— select —</option>
                <option *ngFor="let t of tablesFor(newTable.schemaName)" [value]="t">{{ t }}</option>
              </select>
            </div>
          </div>
          <div class="d-flex flex-wrap gap-3 mt-2">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="nt-edit" [(ngModel)]="newTable.canEditRecord">
              <label class="form-check-label small" for="nt-edit">Edit rec.</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="nt-add" [(ngModel)]="newTable.canAddRecord">
              <label class="form-check-label small" for="nt-add">Add rec.</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="nt-del" [(ngModel)]="newTable.canDeleteRecord">
              <label class="form-check-label small" for="nt-del">Delete rec.</label>
            </div>
          </div>
          <div class="d-flex gap-2 mt-2">
            <button class="btn btn-sm btn-success" (click)="submitAddTable()" [disabled]="!newTableValid">Add</button>
            <button class="btn btn-sm btn-outline-secondary" (click)="cancelAddTable()">Cancel</button>
          </div>
        </div>

        <!-- Table cards -->
        <div class="border rounded mb-3" *ngFor="let table of detail.tables; trackBy: trackByTable">
          <div class="d-flex justify-content-between align-items-center px-3 py-2 bg-light border-bottom">
            <div>
              <span class="fw-bold">{{ table.schemaName }}.{{ table.tableName }}</span>
              <span class="badge bg-primary ms-2" *ngIf="table.isRoot">Root</span>
            </div>
            <div class="d-flex align-items-center gap-3">
              <div class="form-check mb-0">
                <input class="form-check-input" type="checkbox" [id]="'t-edit-' + table.id"
                       [(ngModel)]="table.canEditRecord" (ngModelChange)="saveTablePerms(table)">
                <label class="form-check-label small" [for]="'t-edit-' + table.id">Edit</label>
              </div>
              <div class="form-check mb-0">
                <input class="form-check-input" type="checkbox" [id]="'t-add-' + table.id"
                       [(ngModel)]="table.canAddRecord" (ngModelChange)="saveTablePerms(table)">
                <label class="form-check-label small" [for]="'t-add-' + table.id">Add</label>
              </div>
              <div class="form-check mb-0">
                <input class="form-check-input" type="checkbox" [id]="'t-del-' + table.id"
                       [(ngModel)]="table.canDeleteRecord" (ngModelChange)="saveTablePerms(table)">
                <label class="form-check-label small" [for]="'t-del-' + table.id">Delete</label>
              </div>
              <button class="btn btn-xs btn-outline-danger" *ngIf="!table.isRoot"
                      (click)="removeTable(table)" title="Remove table">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>

          <!-- Fields -->
          <div class="px-3 py-2">
            <table class="table table-sm mb-2 align-middle">
              <thead>
                <tr class="small text-muted">
                  <th>Field</th>
                  <th style="width:90px">Editable</th>
                  <th style="width:40px"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let field of table.fields; let i = index; trackBy: trackByField"
                    class="dpe-drag-row"
                    draggable="true"
                    (dragstart)="onFieldDragStart($event, table, i)"
                    (dragover)="onFieldDragOver($event, table, i)"
                    (dragleave)="onFieldDragLeave($event)"
                    (drop)="onFieldDrop($event, table, i)"
                    (dragend)="onFieldDragEnd()"
                    [class.dpe-row--drag-over]="dragOverTableId === table.id && dragOverFieldIndex === i"
                    [class.dpe-row--dragging]="dragTableId === table.id && dragFieldFromIndex === i">
                  <td>
                    <div class="fw-semibold">{{ fieldDisplayName(table, field) }}</div>
                    <div class="small text-muted" *ngIf="fieldHasDisplayName(table, field)">
                      {{ field.fieldName }}
                    </div>
                  </td>
                  <td>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="field.canEdit"
                           (ngModelChange)="saveField(field)">
                  </td>
                  <td>
                    <button class="btn btn-xs btn-outline-danger"
                            (click)="removeField(table, field)" title="Remove field">
                      <i class="bi bi-x-lg"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="table.fields.length === 0">
                  <td colspan="4" class="text-muted small">No fields configured.</td>
                </tr>
              </tbody>
            </table>

            <!-- Add-field form -->
            <div *ngIf="addFieldForTableId === table.id; else addFieldBtn" class="border-top pt-2">
              <label class="form-label small fw-bold mb-1">Columns</label>
              <div class="border rounded p-2 mb-2 dpe-field-checklist">
                <div class="form-check" *ngFor="let c of availableColumns(table)">
                  <input class="form-check-input" type="checkbox" [id]="'nf-col-' + table.id + '-' + c.name"
                         [checked]="newField.fieldNames.includes(c.name)"
                         (change)="toggleFieldSelection(c.name, $any($event.target).checked)">
                  <label class="form-check-label small" [for]="'nf-col-' + table.id + '-' + c.name">
                    <span class="fw-semibold">{{ c.displayName || c.name }}</span>
                    <span *ngIf="c.displayName && c.displayName !== c.name" class="text-muted ms-1">{{ c.name }}</span>
                    <span *ngIf="c.dataType" class="text-muted ms-1">({{ c.dataType }})</span>
                  </label>
                </div>
                <div class="text-muted small" *ngIf="availableColumns(table).length === 0">
                  All columns for this table have been added.
                </div>
              </div>
              <div class="d-flex flex-wrap align-items-end gap-2">
                <div class="form-check mb-2">
                  <input class="form-check-input" type="checkbox" id="nf-canEdit" [(ngModel)]="newField.canEdit">
                  <label class="form-check-label small" for="nf-canEdit">Editable</label>
                </div>
                <button class="btn btn-sm btn-success mb-2" (click)="submitAddField(table)"
                        [disabled]="!newFieldValid">
                  Add {{ newField.fieldNames.length || '' }} Field{{ newField.fieldNames.length === 1 ? '' : 's' }}
                </button>
                <button class="btn btn-sm btn-outline-secondary mb-2" (click)="cancelAddField()">Done</button>
              </div>
              <div class="text-muted small" *ngIf="newField.fieldNames.length > 0">
                {{ newField.fieldNames.length }} selected — click Add to save, then pick more.
              </div>
            </div>
            <ng-template #addFieldBtn>
              <button class="btn btn-xs btn-outline-primary" (click)="startAddField(table)">
                <i class="bi bi-plus-lg"></i> Add Field
              </button>
            </ng-template>
          </div>
        </div>

        <!-- ───────── Navigations ───────── -->
        <div class="d-flex justify-content-between align-items-center mb-2 mt-4">
          <h6 class="fw-bold mb-0">Navigations</h6>
          <button class="btn btn-sm btn-outline-primary" (click)="startAddNav()"
                  [disabled]="addingNav || detail.tables.length < 1">
            <i class="bi bi-plus-lg"></i> Add Navigation
          </button>
        </div>

        <!-- Add-navigation form -->
        <div class="border rounded p-2 mb-3 bg-light" *ngIf="addingNav">
          <!-- Row 1: Parent table + Cardinality -->
          <div class="row g-2 align-items-end mb-2">
            <div class="col">
              <label class="form-label small fw-bold mb-1">Parent Table</label>
              <select class="form-select form-select-sm" [(ngModel)]="newNav.parentTablePolicyId"
                      (ngModelChange)="onNewNavParentChange()">
                <option value="">— select —</option>
                <option *ngFor="let t of detail.tables" [value]="t.id">
                  {{ t.schemaName }}.{{ t.tableName }}
                </option>
              </select>
            </div>
            <div class="col-auto">
              <label class="form-label small fw-bold mb-1">Cardinality</label>
              <select class="form-select form-select-sm" [(ngModel)]="newNav.cardinality"
                      (ngModelChange)="onNewNavCardinalityChange()">
                <option [ngValue]="Cardinality.OneToOne">One-to-One</option>
                <option [ngValue]="Cardinality.OneToMany">One-to-Many</option>
              </select>
            </div>
          </div>
          <!-- Row 2: Reference schema + table -->
          <div class="row g-2 align-items-end mb-2">
            <div class="col-auto">
              <label class="form-label small fw-bold mb-1">Ref. Schema</label>
              <select class="form-select form-select-sm" [(ngModel)]="newNav.referenceSchema"
                      (ngModelChange)="onNavRefSchemaChange()"
                      [disabled]="!newNav.parentTablePolicyId">
                <option value="">— select —</option>
                <option *ngFor="let s of schemas" [value]="s">{{ s }}</option>
              </select>
            </div>
            <div class="col">
              <label class="form-label small fw-bold mb-1">Reference Table</label>
              <select class="form-select form-select-sm" [(ngModel)]="newNav.referenceTable"
                      (ngModelChange)="onNavRefTableChange()"
                      [disabled]="!newNav.referenceSchema">
                <option value="">— select —</option>
                <optgroup label="Already in policy" *ngIf="navRefTablesInPolicy().length > 0">
                  <option *ngFor="let t of navRefTablesInPolicy()" [value]="t">{{ t }}</option>
                </optgroup>
                <optgroup label="Add from schema" *ngIf="navRefTablesFromMetadata().length > 0">
                  <option *ngFor="let t of navRefTablesFromMetadata()" [value]="t">{{ t }}</option>
                </optgroup>
              </select>
            </div>
          </div>
          <!-- Auto-add notice -->
          <div class="alert alert-info py-1 px-2 small mb-2" *ngIf="newNavRefNotInPolicy && newNav.referenceTable">
            <i class="bi bi-info-circle me-1"></i>
            <strong>{{ newNav.referenceSchema }}.{{ newNav.referenceTable }}</strong> is not yet in this policy —
            it will be added automatically (read-only) when you save this navigation.
          </div>
          <!-- Row 3: Link Alias + Sequence -->
          <div class="row g-2 align-items-end mb-2">
            <div class="col">
              <label class="form-label small fw-bold mb-1">Link Alias</label>
              <select class="form-select form-select-sm" [(ngModel)]="newNav.linkAlias"
                      [disabled]="!newNav.referenceTable">
                <option value="">— select —</option>
                <option *ngFor="let a of newNavAliasOptions()" [value]="a.alias">{{ a.displayName }}</option>
              </select>
              <div class="form-text small text-warning"
                   *ngIf="newNav.referenceTable && newNavAliasOptions().length === 0">
                No foreign key found between these tables for this cardinality.
              </div>
            </div>
            <div class="col-2">
              <label class="form-label small fw-bold mb-1">Seq.</label>
              <input class="form-control form-control-sm" type="number" [(ngModel)]="newNav.sequence">
            </div>
          </div>
          <div class="d-flex gap-2 mt-1">
            <button class="btn btn-sm btn-success" (click)="submitAddNav()" [disabled]="!newNavValid">Add</button>
            <button class="btn btn-sm btn-outline-secondary" (click)="cancelAddNav()">Cancel</button>
          </div>
        </div>

        <table class="table table-sm align-middle" *ngIf="detail.navigations.length > 0">
          <thead>
            <tr class="small text-muted">
              <th>Parent</th>
              <th>Reference</th>
              <th>Alias</th>
              <th style="width:150px">Cardinality</th>
              <th style="width:90px">Sequence</th>
              <th style="width:40px"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let nav of detail.navigations; trackBy: trackByNav">
              <td class="small">{{ tableLabel(nav.parentTablePolicyId) }}</td>
              <td class="small">{{ tableLabel(nav.referenceTablePolicyId) }}</td>
              <td>
                <select class="form-select form-select-sm" [(ngModel)]="nav.linkAlias"
                        (ngModelChange)="saveNavigation(nav)">
                  <option value="">— select —</option>
                  <option *ngFor="let a of navAliasOptionsForNav(nav)"
                          [value]="a.alias">{{ a.displayName }}</option>
                </select>
              </td>
              <td>
                <select class="form-select form-select-sm" [(ngModel)]="nav.cardinality"
                        (ngModelChange)="onNavCardinalityChange(nav)">
                  <option [ngValue]="Cardinality.OneToOne">One-to-One</option>
                  <option [ngValue]="Cardinality.OneToMany">One-to-Many</option>
                </select>
              </td>
              <td>
                <input class="form-control form-control-sm" type="number" [(ngModel)]="nav.sequence"
                       (change)="saveNavigation(nav)" style="width:80px">
              </td>
              <td>
                <button class="btn btn-xs btn-outline-danger"
                        (click)="removeNavigation(nav)" title="Remove navigation">
                  <i class="bi bi-x-lg"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="text-muted small" *ngIf="detail.navigations.length === 0 && !addingNav">
          No navigations configured.
        </div>
      </div>
    </div>

    <ng-template #noSelection>
      <div class="card shadow-sm h-100">
        <div class="card-body d-flex align-items-center justify-content-center text-muted">
          Select a data policy to view or edit it, or create a new one.
        </div>
      </div>
    </ng-template>
  </div>
</div>
